import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, Kicker, SectionH2, SECTION_PAD, useSectionView, track } from './shared';

const CREDIBILITY = [
  'Built while operating a real fashion brand.',
  'Shaped with feedback from early-stage founders.',
];

export const FounderStorySection = () => {
  const ref = useSectionView('founder_story');
  return (
    <section ref={ref} style={{ padding: SECTION_PAD }}>
      <div className="scl-two-col" style={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: '0.85fr 1.15fr', gap: 48, alignItems: 'center' }}>
        <FadeUp>
          <div style={{ position: 'relative' }}>
            <img
              src="/founder-favour-malagu.jpg"
              alt="Favour Malagu, founder of ScalitOS and HOOGLAM"
              data-testid="founder-photo"
              loading="lazy"
              style={{ width: '100%', aspectRatio: '4 / 5', objectFit: 'cover', borderRadius: 18, border: `1px solid ${C.border}`, display: 'block' }}
            />
            <div style={{ position: 'absolute', left: 14, bottom: 14, right: 14, padding: '12px 16px', borderRadius: 12, background: 'rgba(5,7,10,0.82)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: `1px solid ${C.border}` }}>
              <p style={{ fontFamily: DISP, fontWeight: 700, fontSize: 16, color: C.text }}>Favour Malagu</p>
              <p style={{ fontFamily: BODY, fontSize: 12.5, color: C.body, marginTop: 2 }}>Founder, ScalitOS and HOOGLAM</p>
            </div>
          </div>
        </FadeUp>

        <div>
          <FadeUp><Kicker>Built from a real founder problem</Kicker></FadeUp>
          <FadeUp delay={80}>
            <SectionH2 style={{ fontSize: 'clamp(28px, 4vw, 44px)' }}>ScalitOS started inside another business.</SectionH2>
          </FadeUp>
          <FadeUp delay={140}>
            <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
              <p style={{ fontFamily: BODY, fontSize: 16, lineHeight: 1.8, color: C.body }}>
                I built ScalitOS while running <strong style={{ color: C.text }}>HOOGLAM</strong>. I knew what I needed to do to market the brand, but every session began with the same problem: deciding what to work on first.
              </p>
              <p style={{ fontFamily: BODY, fontSize: 16, lineHeight: 1.8, color: C.body }}>
                Before I could execute anything, I was moving between strategy, competitor research, content planning, copywriting, design, scheduling and analytics. ScalitOS began as the system I needed to turn all of that scattered work into one clear next move.
              </p>
              <p style={{ fontFamily: DISP, fontWeight: 700, fontSize: 17, lineHeight: 1.6, color: C.text, borderLeft: `2px solid ${C.lime}`, paddingLeft: 16 }}>
                ScalitOS was built to help founders spend less time managing marketing and more time actually doing it.
              </p>
            </div>
          </FadeUp>
          <FadeUp delay={200}>
            <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 8 }}>
              {CREDIBILITY.map((t, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                  <span aria-hidden="true" style={{ color: C.lime, fontFamily: MONO, fontSize: 12, marginTop: 3 }}>&#10003;</span>
                  <p style={{ fontFamily: BODY, fontSize: 14, color: C.body, lineHeight: 1.6 }}>{t}</p>
                </div>
              ))}
            </div>
          </FadeUp>
          <FadeUp delay={260}>
            <a
              href="https://www.linkedin.com/in/favour-malagu"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-linkedin-link"
              onClick={() => track('founder_linkedin_clicked')}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: 22, fontFamily: BODY, fontSize: 14, fontWeight: 600, color: C.lime }}
            >
              Follow Favour&rsquo;s founder journey →
            </a>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
